import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const Loader = ({ size, ...circleProps }) => (
  <div className="loader">
    <div className={`loader-container ${size}`}>
      <svg className="spinner-container" viewBox="0 0 44 44">
        <circle
          className="path"
          cx="22"
          cy="22"
          r="20"
          fill="none"
          strokeWidth="2"
          {...circleProps}
        />
      </svg>
    </div>
  </div>
);

Loader.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
};

Loader.defaultProps = {
  stroke: '#ddd',
  size: 'lg'
};

export default Loader;
